import React from 'react'
import {
  Segment,
  Item, ItemHeader, ItemContent, Header, Button, Icon
} from 'semantic-ui-react'
import {Link} from "react-router-dom"
import {getStatus} from '../misc/Helpers'


function MyMessages({isTripsLoading, currentUsertrips,
                      oldUsertrips, currentDrivertrips, oldDrivertrips, approve, reject}) {
  let currentUsertripsList
  let oldUsertripsList
  let currentDrivertripsList
  let oldDrivertripsList

  const itemStyle = (data) => {
    return data.length > 0 ? {"display": "block"} : {"display": "none"}
  }

  if (currentUsertrips.length > 0) {
    currentUsertripsList = currentUsertrips.map(usertrip => {
      let trip = usertrip.trip;
      if (usertrip.status === 'APPROVED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Водитель подтвердил вашу Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} <br/>
              Авто {trip.driver.carModel} <br/>
              Номер {trip.driver.carNumber} <br/>
              Телефон {trip.driver.phone}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'REJECTED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Водитель отклонил вашу Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'WAIT') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Ваша заявка ждет подверждения водителя <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} <br/>
              Телефон {trip.driver.phone}
            </Item.Content>
          </Item>
        )
      }
    })
  }
  if (oldUsertrips.length > 0) {
    oldUsertripsList = oldUsertrips.map(usertrip => {
      let trip = usertrip.trip;
      if (usertrip.status === 'APPROVED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Водитель подтвердил вашу Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} <br/>
              Авто {trip.driver.carModel} <br/>
              Номер {trip.driver.carNumber} <br/>
              Телефон {trip.driver.phone}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'REJECTED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Водитель отклонил вашу Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'WAIT') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Ваша заявка осталась без подверждения <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} <br/>
              Телефон {trip.driver.phone}
            </Item.Content>
          </Item>
        )
      }
    })
  }

  if (currentDrivertrips.length > 0) {
    currentDrivertripsList = currentDrivertrips.map(usertrip => {
      let trip = usertrip.trip;
      if (usertrip.status === 'APPROVED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Вы подтвердили поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              пассажиру {usertrip.user.name} <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
              Телефон {usertrip.user.phone}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'REJECTED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Вы отклонили Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              пассажиру {usertrip.user.name}  <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'WAIT') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Ожидает вашего подверждения <br/>
              пассажир {usertrip.user.name}  <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
              телефон {usertrip.user.phone} <br/>
              на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              <br/>
              <Button primary floated='left' onClick={() => reject(usertrip.id)}>
                Отклонить
                <Icon name='right cancel' />
              </Button>
              <Button primary floated='left' onClick={() => approve(usertrip.id)}>
                Подтвердить
                <Icon name='right chevron' />
              </Button>
            </Item.Content>
          </Item>
        )
      }
    })
  }
  if (oldDrivertrips.length > 0) {
    oldDrivertripsList = oldDrivertrips.map(usertrip => {
      let trip = usertrip.trip;
      if (usertrip.status === 'APPROVED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Вы подтвердили поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              пассажиру {usertrip.user.name}  <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
              Телефон {usertrip.user.phone}
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'REJECTED') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Вы отклонили Заявку на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
              пассажиру {usertrip.user.name}  <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
            </Item.Content>
          </Item>
        )
      } else if (usertrip.status === 'WAIT') {
        return (
          <Item key={trip.id}>
            <Item.Content>
              Вы не ответили на заявку <br/>
              пассажир {usertrip.user.name}  <Link to={'/reviews/' + usertrip.user.id}>Смотреть отзывы</Link><br/>
              телефон {usertrip.user.phone} <br/>
              на поездку <br/>
              {trip.fromCity} - {trip.toCity} <br/>
              {new Date(trip.tripTime).toLocaleString('ru',
                {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: false
                })} <br/>
            </Item.Content>
          </Item>
        )
      }
    })
  }

  return (
    <Segment loading={isTripsLoading} color='blue'>
      <Item.Group divided unstackable relaxed style={itemStyle(currentUsertrips)}>
        <Item>
          <Item.Header as='h3'>
            Ваши текущие поездки
          </Item.Header>
        </Item>
        {currentUsertripsList}
      </Item.Group>
      <Item.Group divided unstackable relaxed style={itemStyle(currentDrivertrips)}>
        <Item>
          <Item.Header as='h3'>
            Ваши текущие поездки
          </Item.Header>
        </Item>
        {currentDrivertripsList}
      </Item.Group>
      <Item.Group divided unstackable relaxed style={itemStyle(oldUsertrips)}>
        <Item>
          <Item.Header as='h3'>
            Ваши прошлые поездки
          </Item.Header>
        </Item>
        {oldUsertripsList}
      </Item.Group>
      <Item.Group divided unstackable relaxed style={itemStyle(oldDrivertrips)}>
        <Item>
          <Item.Header as='h3'>
            Ваши прошлые поездки
          </Item.Header>
        </Item>
        {oldDrivertripsList}
      </Item.Group>
    </Segment>
  )
}

export default MyMessages
